import { render, staticRenderFns } from "./University.vue?vue&type=template&id=442e8b10&scoped=true&"
import script from "./University.vue?vue&type=script&lang=js&"
export * from "./University.vue?vue&type=script&lang=js&"
import style0 from "./University.vue?vue&type=style&index=0&id=442e8b10&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442e8b10",
  null
  
)

export default component.exports